var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFriend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.227 21.5001C10.5861 20.4452 10.2481 19.2343 10.25 18.0001C10.25 15.8571 11.249 13.9471 12.806 12.7101C9.07817 12.0301 5.23026 12.7274 1.978 14.6721C1.526 14.9421 1.25 15.4291 1.25 15.9551V19.7501C1.25 20.7171 2.033 21.5001 3 21.5001H11.227Z",
    fill: "#2A2A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1C9.37622 1 8.75855 1.12286 8.18225 1.36157C7.60596 1.60028 7.08232 1.95016 6.64124 2.39124C6.20016 2.83232 5.85028 3.35596 5.61157 3.93225C5.37286 4.50855 5.25 5.12622 5.25 5.75C5.25 6.37378 5.37286 6.99145 5.61157 7.56775C5.85028 8.14404 6.20016 8.66768 6.64124 9.10876C7.08232 9.54984 7.60596 9.89972 8.18225 10.1384C8.75855 10.3771 9.37622 10.5 10 10.5C11.2598 10.5 12.468 9.99955 13.3588 9.10876C14.2496 8.21796 14.75 7.00978 14.75 5.75C14.75 4.49022 14.2496 3.28204 13.3588 2.39124C12.468 1.50044 11.2598 1 10 1Z",
    fill: "#2A2A2A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7616 2.85C13.3186 2.27383 12.7489 1.8073 12.0968 1.4865C11.4446 1.16571 10.7274 0.999247 10.0006 1C9.31332 0.999918 8.63422 1.14897 8.01017 1.43687C7.38612 1.72478 6.83197 2.14467 6.38598 2.66757C5.93999 3.19047 5.61279 3.80393 5.42695 4.46559C5.24111 5.12725 5.20107 5.82136 5.30958 6.5H5.97358C6.83758 6.56 8.19158 6.478 9.57058 6.049C10.9666 5.614 12.4566 4.802 13.4506 3.347L13.4596 3.334L13.4676 3.321L13.7626 2.849L13.7616 2.85Z",
    fill: "#2A2A2A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 12.25C16.2449 12.25 15.4972 12.3987 14.7996 12.6877C14.1019 12.9767 13.4681 13.4002 12.9341 13.9341C12.4002 14.4681 11.9767 15.1019 11.6877 15.7996C11.3987 16.4972 11.25 17.2449 11.25 18C11.25 18.7551 11.3987 19.5028 11.6877 20.2004C11.9767 20.8981 12.4002 21.5319 12.9341 22.0659C13.4681 22.5998 14.1019 23.0233 14.7996 23.3123C15.4972 23.6013 16.2449 23.75 17 23.75C18.525 23.75 19.9875 23.1442 21.0659 22.0659C22.1442 20.9875 22.75 19.525 22.75 18C22.75 16.475 22.1442 15.0125 21.0659 13.9341C19.9875 12.8558 18.525 12.25 17 12.25Z",
    fill: "#91172C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.75 18C19.75 18.1989 19.671 18.3897 19.5303 18.5303C19.3897 18.671 19.1989 18.75 19 18.75H15C14.8011 18.75 14.6103 18.671 14.4697 18.5303C14.329 18.3897 14.25 18.1989 14.25 18C14.25 17.8011 14.329 17.6103 14.4697 17.4697C14.6103 17.329 14.8011 17.25 15 17.25H19C19.1989 17.25 19.3897 17.329 19.5303 17.4697C19.671 17.6103 19.75 17.8011 19.75 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFriend);
export default __webpack_public_path__ + "static/media/deleteFriend.6252df59d3f57c34ef29f394badbb632.svg";
export { ForwardRef as ReactComponent };